export enum ApSchedulerBuildStage {
    edit = 'EDIT',
    schedule = 'SCHEDULE',
    complete = 'COMPLETE',
}
